module.exports = __webpack_public_path__ + "static/media/Spinner.3afa91dd.gif";